import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectConfigSettings } from '../store/slices/config/configSelectors';

const usePlaceNavigate = () => {
  const navigate = useNavigate();
  const { place, rentalType } = useSelector(selectConfigSettings);

  // Handles internal navigation adding the proper place name and rentaltype as a prefix to the desired path
  // This is required in order to easily navigate from any page to any other page without explicitly adding /fl-breward-city_of_margate-ltr-portal/otherpage
  // as a part of the navigation
  return (path, options) => {
    if (path !== '-1' && path !== -1) {
      return navigate(getInternalUrl(place, rentalType, path), options);
    }
    navigate(path, options);
  };
};

export const useInternalUrl = (path = '') => {
  const { place, rentalType } = useSelector(selectConfigSettings);
  return getInternalUrl(place, rentalType, path);
};

export const getInternalUrl = (place, rentalType, path) => `/${place}-${rentalType}-portal${path}`;

export default usePlaceNavigate;
